import React from 'react';
import { Input, InputNumber } from 'formik-antd';
import FormControl from '~/components/Form/FormControl';
import { SelectAntdFormik } from '~/components/Pagination/styles';
import InputCurrency from '~/components/Form/InputCurrency';
import Button from '~/components/Button';
import i18next from 'i18next';
import { FaTrash } from 'react-icons/fa';
import { Flex } from 'antd';
import DateComponent from '~/components/DateComponent';

export const bacthesItemsColumns = (fetchedItems, errors, fluidPermissions, setFieldValue) => {
  return [
    {
      title: i18next.t('fields:batch.productType'),
      dataIndex: 'item_id',
      key: 'item_id',
      width: '30%',
      render: (_, record, index) => (
        <FormControl field={`batches_items.${index}.item_id`} error={errors?.batches_items?.[index]?.item_id} list>
          <SelectAntdFormik
            placeholder="Selecione um produto"
            name={`batches_items.${index}.item_id`}
            onSelect={(_, options) => {
              setFieldValue(`batches_items.${index}.item_name`, options.children);
            }}
            disabled={!fluidPermissions()}
          >
            <SelectAntdFormik.Option value="">{i18next.t('fields:batch.select')}</SelectAntdFormik.Option>
            {fetchedItems?.map((item) => (
              <SelectAntdFormik.Option key={item.id} value={item.id}>
                <p style={{ color: item.deleted_at ? 'red' : '', fontWeight: 'bold' }}>{item.name}</p>
              </SelectAntdFormik.Option>
            ))}
          </SelectAntdFormik>
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:batch.inputAmount'),
      dataIndex: 'input_amount',
      key: 'input_amount',
      render: (_, record, index) => (
        <FormControl
          field={`batches_items.${index}.input_amount`}
          error={errors?.batches_items?.[index]?.input_amount}
          list
        >
          <InputNumber name={`batches_items.${index}.input_amount`} disabled={!fluidPermissions()} />
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:batch.costPrice'),
      dataIndex: 'cost_price',
      key: 'cost_price',
      render: (_, record, index) => (
        <FormControl
          field={`batches_items.${index}.cost_price`}
          error={errors?.batches_items?.[index]?.cost_price}
          list
        >
          <InputCurrency name={`batches_items.${index}.cost_price`} disabled={!fluidPermissions()} />
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:batch.dueDate'),
      dataIndex: 'due_date',
      key: 'due_date',
      render: (_, record, index) => (
        <FormControl field={`batches_items.${index}.due_date`} error={errors?.batches_items?.[index]?.due_date} list>
          <DateComponent name={`batches_items.${index}.due_date`} disabled={!fluidPermissions()} />
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:batch.provider'),
      dataIndex: 'provider',
      key: 'provider',
      render: (_, record, index) => (
        <FormControl field={`batches_items.${index}.provider`} error={errors?.batches_items?.[index]?.provider} list>
          <Input name={`batches_items.${index}.provider`} disabled={!fluidPermissions()} />
        </FormControl>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_, record, index) => (
        <Flex align="center" justify="center">
          <Button
            color="danger"
            title="Remover item"
            size="small"
            style={{ width: '30px' }}
            onClick={() => record.remove(index)}
            disabled={!fluidPermissions()}
            icon={<FaTrash />}
          />
        </Flex>
      ),
    },
  ];
};
